import { put, call, takeLatest } from 'redux-saga/effects';
import { BIDCASEREVIEW } from '../constants';
import * as actions from '../actions';
import { queryBidCaseReview } from '../api';

export default function* watchAccount() {
    yield takeLatest(BIDCASEREVIEW.BIDCASEREVIEW_QUERY, bidCaseReviewSaga)
}

export function* bidCaseReviewSaga(action) {
    try {
        yield put(actions.queryBidCaseReviewLoad());
        const resultJson = yield call(queryBidCaseReview, action.formData);
        const token = "";//resultJson.token;
        const result = resultJson.result;
        yield put(actions.queryBidCaseReviewSuccess(token, result));
    } catch (error) {
        console.error(error);
    }
}